import { flattenClinicCreateData } from '@/pages/admin/site-admin-clinic-info/clinicFormSchema';
import { apiClient } from '@/shared/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

type Response<T> = {
  data: T;
};

type FlattenedClinicData = ReturnType<typeof flattenClinicCreateData>;

export const getClinicInfoCopy = async (
  id: string,
  siteType: string | null
): Promise<Response<FlattenedClinicData>> => {
  const response = await apiClient.get<Response<FlattenedClinicData>>(
    `/admin/${siteType}/clinic-informations/${id}/copy`
  );
  return response.data;
};

export const useSiteAdminCopyClinicInfo = (id: string) => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';

  return useQuery({
    queryKey: ['clinic-info-copy', id, currentSite],
    queryFn: () => getClinicInfoCopy(id, currentSite),
    enabled: !!currentSite && !!id,
  });
};
